<template>
    <div class="lg">
        <div class="lg-c">
            <!-- logo -->
            <div class="lg-logo"></div>
            <!--            <div class="lg-title"></div>暂时去掉-->
            <!-- 表单 -->
            <div class="lg-f">
                <Form
                    ref="uInfo"
                    :model="uInfo"
                    :rules="ruleValidate"
                    :itemMarginBottom="28"
                    @keydown.enter.native="onSubmit"
                >
                    <form-item prop="phone">
                        <span class="lg-f-label">账号</span>
                        <base-input
                            v-model="uInfo.phone"
                            class="lg-f-i"
                            :maxlength="60"
                            :disabled="loading"
                        ></base-input>
                    </form-item>
                    <form-item prop="password">
                        <span class="lg-f-label">密码</span>
                        <base-input
                            v-model="uInfo.password"
                            class="lg-f-i"
                            type="password"
                            :disabled="loading"
                            :maxlength="60"
                        ></base-input>
                    </form-item>
                </Form>
                <Button
                    class="lg-f-submit"
                    type="primary"
                    :loading="loading"
                    @click="onSubmit"
                    >登 录</Button
                >
            </div>
            <!-- 版权 -->
            <p class="lg-cr">
                <span class="lg-cr-i">©</span>{{ curYear }}
                <span class="lg-cr-t" @click="toCompany">预知科技旗下产品</span>
            </p>
        </div>
    </div>
</template>
<script>
import mLogin from '_v/common/m-login'

export default {
    mixins: [mLogin],
    data() {
        return {}
    },
}
</script>
<style lang="less" scoped>
@lg-input-color: #eeeff2;

.place-holder() {
    color: #fff;
    -webkit-text-fill-color: #fff;
}

.auto-fill() {
    -webkit-text-fill-color: #fff;
    //     -webkit-box-shadow: 0 0 0px 1000px #000 inset;
    transition: background-color 9999999s ease-in-out 0s;
}

.lg {
    width: 100%;
    height: 100%;
    background: url('./img/login-bg.jpg') no-repeat center;
    background-size: cover;

    &-c {
        box-sizing: content-box;
        width: 400px;
        position: absolute;
        padding-top: 40px;
        padding-left: 20px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &-logo {
        height: 70px;
        background: url('./img/login-logo.png') no-repeat center;
        background-size: contain;
    }

    &-title {
        height: 70px;
        background: url('./img/login-title.png') no-repeat center;
        background-size: contain;
    }

    &-f {
        margin: 32px auto 0;
        width: 310px;
        padding-left: 40px;
        text-align: center;
        color: @lg-input-color;

        &-label {
            position: absolute;
            left: -40px;
            font-size: 16px;
        }
        &-i {
            position: relative;
            top: -1px;
            width: 100%;
            height: 20px;
            line-height: 20px;
            border: 0;
            border-bottom: 1px solid @lg-input-color;
            box-shadow: none;
            background-color: transparent;
            outline: none;
            font-size: 14px;
            text-indent: 10px;
            color: @lg-input-color;

            // 清除浏览器自动填充样式
            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus {
                .auto-fill();
            }

            // placeholder 样式修改
            &::placeholder,
            ::-webkit-input-placeholder,
            ::-moz-placeholder,
            :-ms-input-placeholder {
                .place-holder();
            }
        }

        &-submit {
            margin-top: 6px;
            margin-left: -10px;
            width: 240px;
            height: 40px;
            line-height: 28px;
            border-radius: 16px;
            font-size: 18px;
        }
    }

    &-cr {
        margin-top: 130px;
        text-align: center;
        font-size: 12px;
        color: @lg-input-color;

        &-i {
            margin-right: 1px;
        }

        &-t {
            text-decoration: underline;
            cursor: pointer;
            &:hover {
                color: #ffffff;
            }
        }
    }
}
</style>
